import styled from 'styled-components';

import $Icon from '../Icon';
import {Button} from '../Button';

import {commonPalette} from '../../styles/palette';

export const LoginForm = styled.form`
  max-width: 428px;
`;

export const StyledIcon = styled($Icon).attrs({})`
  width: 16px;
  height: 90%;
  margin-bottom: 3px;
  margin-right: 2px;
`;

export const StyledText = styled.div`
  color: ${commonPalette.textBrand};
  margin: ${({isMobile}) => (isMobile ? '' : '10px 0')};
  text-align: ${({alignText}) => alignText || 'center'};
  font-size: 14px;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin: ${({isMobile}) => (isMobile ? '10px 0 15px 0' : '5px 0 20px 0')};
`;

export const EmailWrapperDiv = styled.div`
  margin-bottom: 5px;
`;

export const ErrorNotification = styled.div`
  color: ${commonPalette.newRed};
  font-size: 14px;
  font-family: lato;
  padding: 10px 2px 10px 5px;
  margin-left: 15px;
`;

export const StyledErrorWrapper = styled.div`
  display: flex;
`;

export const StyledErrorIcon = styled($Icon).attrs({})`
  width: 16px;
  color: ${commonPalette.newRed};
  display: inline-block;
  margin-top: 9px;
  position: absolute;
`;

export const StyledLink = styled.a`
  text-decoration: underline;
  color: ${commonPalette.newRed};
  cursor: pointer;
  &:hover {
    color: ${commonPalette.newRed};
  }
`;
export const getHeight = () => ({
  height: '56px',
  padding: '0px 40px 0px 16px'
});

export const StyledButtonLink = styled.a`
  color: ${commonPalette.textBrand};
  &:hover {
    color: ${commonPalette.textBrand};
  }
`;
